import React, { createContext, useContext, useState, useEffect } from 'react';
import { useVisitorSettings } from '../hooks/useVisitorSettings';

type Theme = 'light' | 'dark';

interface ThemeContextType { theme: Theme; toggleTheme: () => void; }

const ThemeContext = createContext<ThemeContextType>({ theme: 'light', toggleTheme: () => {} });

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme, toggleTheme } = useVisitorSettings();
  
  useEffect(() => { document.documentElement.setAttribute('data-theme', theme); localStorage.setItem('nidave-theme', theme); }, [theme]);
  return <ThemeContext.Provider value={{ theme, toggleTheme: () => toggleTheme() }}>{children}</ThemeContext.Provider>;
};
export const useTheme = () => useContext(ThemeContext);
